export const GET_PENDING_REQUEST_DATA = "GET_PENDING_REQUEST_DATA";
export const GET_PENDING_REQUEST_DATA_SUCCESS =
  "GET_PENDING_REQUEST_DATA_SUCCESS";
export const GET_PENDING_REQUEST_DATA_FAILURE =
  "GET_PENDING_REQUEST_DATA_FAILURE";

export const GET_PENDING_PAYMENT_DATA = "GET_PENDING_PAYMENT_DATA";
export const GET_PENDING_PAYMENT_DATA_SUCCESS =
  "GET_PENDING_PAYMENT_DATA_SUCCESS";
export const GET_PENDING_PAYMENT_DATA_FAILURE =
  "GET_PENDING_PAYMENT_DATA_FAILURE";

export const GET_TOTAL_PARTNERS_DATA = "GET_TOTAL_PARTNERS_DATA";
export const GET_TOTAL_PARTNERS_DATA_SUCCESS =
  "GET_TOTAL_PARTNERS_DATA_SUCCESS";
export const GET_TOTAL_PARTNERS_DATA_FAILURE =
  "GET_TOTAL_PARTNERS_DATA_FAILURE";

export const GET_TOTAL_CUSTOMERS_DATA = "GET_TOTAL_CUSTOMERS_DATA";
export const GET_TOTAL_CUSTOMERS_DATA_SUCCESS =
  "GET_TOTAL_CUSTOMERS_DATA_SUCCESS";
export const GET_TOTAL_CUSTOMERS_DATA_FAILURE =
  "GET_TOTAL_CUSTOMERS_DATA_FAILURE";

export const GET_COMPLETED_TRIPS_DATA = "GET_COMPLETED_TRIPS_DATA";
export const GET_COMPLETED_TRIPS_DATA_SUCCESS =
  "GET_COMPLETED_TRIPS_DATA_SUCCESS";
export const GET_COMPLETED_TRIPS_DATA_FAILURE =
  "GET_COMPLETED_TRIPS_DATA_FAILURE";

export const GET_CANCELLED_TRIPS_DATA = "GET_CANCELLED_TRIPS_DATA";
export const GET_CANCELLED_TRIPS_DATA_SUCCESS =
  "GET_CANCELLED_TRIPS_DATA_SUCCESS";
export const GET_CANCELLED_TRIPS_DATA_FAILURE =
  "GET_CANCELLED_TRIPS_DATA_FAILURE";

export const GET_INQUIRY_TRIPS_DATA = "GET_INQUIRY_TRIPS_DATA";
export const GET_INQUIRY_TRIPS_DATA_SUCCESS = "GET_INQUIRY_TRIPS_DATA_SUCCESS";
export const GET_INQUIRY_TRIPS_DATA_FAILURE = "GET_INQUIRY_TRIPS_DATA_FAILURE";

export const GET_TOTAL_BOOKINGS_DATA = "GET_TOTAL_BOOKINGS_DATA";
export const GET_TOTAL_BOOKINGS_DATA_SUCCESS =
  "GET_TOTAL_BOOKINGS_DATA_SUCCESS";
export const GET_TOTAL_BOOKINGS_DATA_FAILURE =
  "GET_TOTAL_BOOKINGS_DATA_FAILURE";

export const GET_TOTAL_REVENUE_DATA = "GET_TOTAL_REVENUE_DATA";
export const GET_TOTAL_REVENUE_DATA_SUCCESS = "GET_TOTAL_REVENUE_DATA_SUCCESS";
export const GET_TOTAL_REVENUE_DATA_FAILURE = "GET_TOTAL_REVENUE_DATA_FAILURE";

export const GET_PARTNER_PERFORMANCE_DATA = "GET_PARTNER_PERFORMANCE_DATA";
export const GET_PARTNER_PERFORMANCE_DATA_SUCCESS =
  "GET_PARTNER_PERFORMANCE_DATA_SUCCESS";
export const GET_PARTNER_PERFORMANCE_DATA_FAILURE =
  "GET_PARTNER_PERFORMANCE_DATA_FAILURE";

export const GET_REGIONAL_INSIGHTS_DATA = "GET_REGIONAL_INSIGHTS_DATA";
export const GET_REGIONAL_INSIGHTS_DATA_SUCCESS =
  "GET_REGIONAL_INSIGHTS_DATA_SUCCESS";
export const GET_REGIONAL_INSIGHTS_DATA_FAILURE =
  "GET_REGIONAL_INSIGHTS_DATA_FAILURE";

export const GET_MODEL_PERFORMANCE_DATA = "GET_MODEL_PERFORMANCE_DATA";
export const GET_MODEL_PERFORMANCE_DATA_SUCCESS =
  "GET_MODEL_PERFORMANCE_DATA_SUCCESS";
export const GET_MODEL_PERFORMANCE_DATA_FAILURE =
  "GET_MODEL_PERFORMANCE_DATA_FAILURE";

export const GET_PENDING_REQUEST_LAST_WEEK_DATA =
  "GET_PENDING_REQUEST_LAST_WEEK_DATA";
export const GET_PENDING_REQUEST_LAST_WEEK_DATA_SUCCESS =
  "GET_PENDING_REQUEST_LAST_WEEK_DATA_SUCCESS";
export const GET_PENDING_REQUEST_LAST_WEEK_DATA_FAILURE =
  "GET_PENDING_REQUEST_LAST_WEEK_DATA_FAILURE";

export const GET_RENTAL_PARTNER_DATA = "GET_RENTAL_PARTNER_DATA";
export const GET_RENTAL_PARTNER_DATA_SUCCESS =
  "GET_RENTAL_PARTNER_DATA_SUCCESS";
export const GET_RENTAL_PARTNER_DATA_FAILURE =
  "GET_RENTAL_PARTNER_DATA_FAILURE";

export const GET_RE_TOTAL_BOOKINGS_DATA = "GET_RE_TOTAL_BOOKINGS_DATA";
export const GET_RE_TOTAL_BOOKINGS_DATA_SUCCESS =
  "GET_RE_TOTAL_BOOKINGS_DATA_SUCCESS";
export const GET_RE_TOTAL_BOOKINGS_DATA_FAILURE =
  "GET_RE_TOTAL_BOOKINGS_DATA_FAILURE";

export const GET_RE_TOTAL_REVENUE_DATA = "GET_RE_TOTAL_REVENUE_DATA";
export const GET_RE_TOTAL_REVENUE_DATA_SUCCESS =
  "GET_RE_TOTAL_REVENUE_DATA_SUCCESS";
export const GET_RE_TOTAL_REVENUE_DATA_FAILURE =
  "GET_RE_TOTAL_REVENUE_DATA_FAILURE";

export const GET_RE_MOST_BOOKED_RIDES_DATA = "GET_RE_MOST_BOOKED_RIDES_DATA";
export const GET_RE_MOST_BOOKED_RIDES_DATA_SUCCESS =
  "GET_RE_MOST_BOOKED_RIDES_DATA_SUCCESS";
export const GET_RE_MOST_BOOKED_RIDES_DATA_FAILURE =
  "GET_RE_MOST_BOOKED_RIDES_DATA_FAILURE";

export const GET_RE_MOST_BOOKED_TOURS_DATA = "GET_RE_MOST_BOOKED_TOURS_DATA";
export const GET_RE_MOST_BOOKED_TOURS_DATA_SUCCESS =
  "GET_RE_MOST_BOOKED_TOURS_DATA_SUCCESS";
export const GET_RE_MOST_BOOKED_TOURS_DATA_FAILURE =
  "GET_RE_MOST_BOOKED_TOURS_DATA_FAILURE";

export const GET_RE_INVENTORY_STATUS_DATA = "GET_RE_INVENTORY_STATUS_DATA";
export const GET_RE_INVENTORY_STATUS_DATA_SUCCESS =
  "GET_RE_INVENTORY_STATUS_DATA_SUCCESS";
export const GET_RE_INVENTORY_STATUS_DATA_FAILURE =
  "GET_RE_INVENTORY_STATUS_DATA_FAILURE";

export const GET_RE_INVENTORY_BOOKING_CALENDAR_DATA =
  "GET_RE_INVENTORY_BOOKING_CALENDAR_DATA";
export const GET_RE_INVENTORY_BOOKING_CALENDAR_DATA_SUCCESS =
  "GET_RE_INVENTORY_BOOKING_CALENDAR_DATA_SUCCESS";
export const GET_RE_INVENTORY_BOOKING_CALENDAR_DATA_FAILURE =
  "GET_RE_INVENTORY_BOOKING_CALENDAR_DATA_FAILURE";

export const GET_RE_GANTT_CHART_DATA = "GET_RE_GANTT_CHART_DATA";
export const GET_RE_GANTT_CHART_DATA_SUCCESS =
  "GET_RE_GANTT_CHART_DATA_SUCCESS";
export const GET_RE_GANTT_CHART_DATA_FAILURE =
  "GET_RE_GANTT_CHART_DATA_FAILURE";

export const GET_RE_TOUR_STATUS_DATA = "GET_RE_TOUR_STATUS_DATA";
export const GET_RE_TOUR_STATUS_DATA_SUCCESS =
  "GET_RE_TOUR_STATUS_DATA_SUCCESS";
export const GET_RE_TOUR_STATUS_DATA_FAILURE =
  "GET_RE_TOUR_STATUS_DATA_FAILURE";

export const GET_RE_MAP_DATA = "GET_RE_MAP_DATA";
export const GET_RE_MAP_DATA_SUCCESS = "GET_RE_MAP_DATA_SUCCESS";
export const GET_RE_MAP_DATA_FAILURE = "GET_RE_MAP_DATA_FAILURE";

export const CLEAR_PREVIOUS_REDUCER = "CLEAR_PREVIOUS_REDUCER";

export const GET_MOTORCYCLE_OUT_OF_BUSINESS_DATA =
  "GET_MOTORCYCLE_OUT_OF_BUSINESS_DATA";
export const GET_MOTORCYCLE_OUT_OF_BUSINESS_SUCCESS =
  "GET_MOTORCYCLE_OUT_OF_BUSINESS_SUCCESS";
export const GET_MOTORCYCLE_OUT_OF_BUSINESS_FAILURE =
  "GET_MOTORCYCLE_OUT_OF_BUSINESS_FAILURE";

export const GET_TOP_PARTNERS_WITH_PENDING_LEADS =
  "GET_TOP_PARTNERS_WITH_PENDING_LEADS";
export const GET_TOP_PARTNERS_WITH_PENDING_LEADS_SUCCESS =
  "GET_TOP_PARTNERS_WITH_PENDING_LEADS_SUCCESS";
export const GET_TOP_PARTNERS_WITH_PENDING_LEADS_FAILURE =
  "GET_TOP_PARTNERS_WITH_PENDING_LEADS_FAILURE";

export const GET_INVENTORY_STATUS_PENDING = "GET_INVENTORY_STATUS_PENDING";
export const GET_INVENTORY_STATUS_SUCCESS = "GET_INVENTORY_STATUS_SUCCESS";
export const GET_INVENTORY_STATUS_FAILURE = "GET_INVENTORY_STATUS_FAILURE";

export const GET_MOTORCYCLE_OUT_OF_BUSINESS_PARTNER_PENDING =
  "GET_MOTORCYCLE_OUT_OF_BUSINESS_PARTNER_PENDING";
export const GET_MOTORCYCLE_OUT_OF_BUSINESS_PARTNER_SUCCESS =
  "GET_MOTORCYCLE_OUT_OF_BUSINESS_PARTNER_SUCCESS";
export const GET_MOTORCYCLE_OUT_OF_BUSINESS_PARTNER_FAILURE =
  "GET_MOTORCYCLE_OUT_OF_BUSINESS_PARTNER_FAILURE";
